import { paycorDownloadFile, manualPaycorDownloadFile } from "../api/paycor"; 

// Function to download files for the given date range
const downloadFiles = async (startDate: string, endDate: string): Promise<any> => {

    try {
        // Make the API request to download the file based on startDate and endDate
        const apiResults = await paycorDownloadFile(startDate, endDate);

        // Log the API results for debugging purposes
        console.log(apiResults);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Download Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Log the authData for debugging purposes
        console.log(authData);

        // Return the actual data from the response
        return authData.data;

    } catch (err) {
        // Log any errors encountered during the download process
        console.error("Error in paycorDownloadFile", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

const manualDownload = async (startDate: string, endDate: string, empIDs: string): Promise<any> => {

    try {
        // Make the API request to download the file based on startDate and endDate
        const apiResults = await manualPaycorDownloadFile(startDate, endDate, empIDs);

        // Log the API results for debugging purposes
        console.log(apiResults);

        // Check if the API results are not returned or empty, throw an error
        if (!apiResults) { 
            throw new Error("Download Failed.");
        }

        // Store the results from the API response
        const authData = apiResults;

        // Log the authData for debugging purposes
        console.log(authData);

        // Return the actual data from the response
        return authData.data;

    } catch (err) {
        // Log any errors encountered during the download process
        console.error("Error in manualPaycorDownloadFile", err);

        // Throw the error for handling in calling code
        throw err;
    }

};

// Export the downloadFiles function to be used in other parts of the application
export { downloadFiles, manualDownload };
